import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";

// Applicant flow (submit)
export function PublicApplicantRoute({ children }: any) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = localStorage.getItem("applicantToken");
  const isAuthenticated = Boolean(token);
  const location = useLocation();
  const currentPath = location.pathname;
  const isResetPassword = currentPath.includes("/reset-password");
  // Allow access to /assessment-confirmation regardless of authentication
  if (location.pathname.includes("/assessment-confirmation")) {
    return <>{children}</>;
  }

  return isAuthenticated && !isResetPassword ? (
    <Navigate to={`/${currentLanguage}/my-assessments`} />
  ) : (
    <>{children}</>
  );
}

// Applicant flow (submit)
export function PrivateApplicantRoute({ children }: any) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const token = localStorage.getItem("applicantToken");
  const isAuthenticated = Boolean(token);
  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to={`/${currentLanguage}/applicant-login`} />
  );
}
